import { httpClient } from '@/shell';
import {
  withIdempotency,
  type BidPlacementInput,
  type BidPlacementResult,
  type PublicItemDetail,
} from '@neon-one/auctions-types';

// Wrap be-007 POST /api/v1/bids. Idempotency-Key per api-contracts §1
// flows in via the typed `withIdempotency` helper so the kernel httpClient
// envelope-unwrap interceptor returns BidPlacementResult.data directly.
export const bidApi = {
  async place(
    input: BidPlacementInput,
    idempotencyKey: string,
  ): Promise<BidPlacementResult> {
    const resp = await httpClient().post<BidPlacementResult>(
      '/bids',
      input,
      withIdempotency(idempotencyKey),
    );
    return resp.data;
  },

  // Item detail re-fetch — the bid feature owns its own copy because
  // cross-feature imports (e.g. of catalog's loader) are banned by lint.
  // Both features call the same public endpoint via the shared client.
  async itemDetail(slug: string, itemId: number): Promise<PublicItemDetail> {
    const resp = await httpClient().get<PublicItemDetail>(
      `/public/events/${encodeURIComponent(slug)}/items/${itemId}`,
    );
    return resp.data;
  },

  // Bundle detail re-fetch — mirrors itemDetail above for bundle-mode
  // bid sheets/inline forms.
  async bundleDetail(slug: string, bundleId: number): Promise<PublicItemDetail> {
    const resp = await httpClient().get<PublicItemDetail>(
      `/public/events/${encodeURIComponent(slug)}/bundles/${bundleId}`,
    );
    return resp.data;
  },
};
